import axios from 'axios';
import useSWR from 'swr';
const baseURL = process.env.REACT_APP_API_BASE_URL
const axiosInstance = axios.create({
  baseURL
});

axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken') || '';
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

const fetcher = (url) => axiosInstance.get(url).then(res => res.data);

export const useAxiosSWR = (url, config = {}) => {
  const { data, error, mutate, isLoading } = useSWR(url, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
    ...config,
  });

  return {
    data,
    error,
    mutate,
    isLoading
  };
};

// const handleUnauthorized = () => {
//   localStorage.removeItem('authToken');
//   window.location.href = `/login?random=${(Math.random() + '').replace('.', '')}&from=${window.location.pathname}`;
// };

// axiosInstance.interceptors.response.use(
//   response => response.data,
//   error => {
//     const apiUrl = error?.request?.responseURL;
//     if (typeof apiUrl === 'string' && (apiUrl.includes('/cms/login') || apiUrl.includes('/cms/changePassword')  || apiUrl.includes('/cms/config/get') )) {
//       return Promise.reject(error);
//     }
//     if (error.response && error.response.status === 401) {
//       handleUnauthorized();
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
